import { Component } from '@angular/core';
import { FOOTER_TEXT } from '../core/consts/consts';
import { SidenavComponent } from './sidenav/sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';

import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-layout',
  standalone: true,
  imports: [MatSidenavModule, SidenavComponent, RouterOutlet],
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.scss',
})
export class LayoutComponent {
  readonly footerText = FOOTER_TEXT;
  sidenavOpened = true;

  closeSidenav(): void {
    this.sidenavOpened = false;
  }
}
